import React, { useState, useCallback } from "react";
import styles from "./styles.module.scss";
import VideoPlayer from "app/components/VideoPlayer";
import { cls } from "app/utils";
import { MediaModel } from "app/models";

interface IVideoViewerProps {
  videoMedia: MediaModel;
}

const VideoViewer = ({ videoMedia }: IVideoViewerProps) => {
  const [selectedVideo, setSelectedVideo] = useState<MediaModel>(videoMedia);

  const onSelectMulticam = useCallback((video: MediaModel) => {
    setSelectedVideo(video);
  }, []);

  const multicamData = React.useMemo(() => {
    return videoMedia?.childResources
      ? [videoMedia, ...videoMedia.childResources]
      : [videoMedia];
  }, [videoMedia]);

  const hasMulticamVideos = videoMedia?.childResources?.length > 0;

  return (
    <div className={cls(styles.video_container, styles.is_horizontal)}>
      <div className={styles.video_wrapper}>
        <VideoPlayer src={selectedVideo} />
      </div>

      {hasMulticamVideos && (
        <div className={styles.mutlicam_footer}>
          {multicamData.map((video: MediaModel, index) => (
            <button
              key={video.id}
              type="button"
              className={styles.multicam_thumb_wrapper}
              onClick={() => onSelectMulticam(video)}
              aria-label={`Switch to camera ${index + 1}`}
            >
              <div
                className={cls(styles.multicam_counted_num, {
                  [styles.active_multicam_counted_num]:
                    video?.id === selectedVideo?.id,
                })}
              >
                <span>{index + 1}</span>
              </div>
              <img
                className={cls(styles.multicam_thumb, {
                  [styles.active_multicam_thumb]:
                    video?.id === selectedVideo?.id,
                })}
                alt={`Camera ${index + 1} thumbnail`}
                src={video?.thumbnails?.medium}
                loading="lazy"
                {...({} as any)}
              />
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default VideoViewer;
